import React from 'react';
import ExternalShareContentRenderer from '@confluence-classic/confluence-fabric-editor/src/components/ExternalShareContentRenderer/index.ts';

import { ExternalSharePageLoader } from '@confluence/external-share/entry-points/ExternalSharePage.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { getUniquePageLoadId } from '@confluence/unique-page-load-id/entry-points/UniquePageLoadId.ts';

export const ExternalShareRoute = ({ params: { contentId, externalToken }, hash }: RouteMatch) => (
	<ExternalSharePageLoader
		contentId={contentId === 'undefined' ? undefined : contentId}
		shareToken={externalToken}
		queryHash={hash}
		ContentRenderer={ExternalShareContentRenderer}
	/>
);

ExternalShareRoute.NAVIGATION_PARAMS = ({ name, params: { contentId } }: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'viewPageScreen',
			id: contentId,
			attributes: {
				isPublicView: true,
				pageLoadInfo: getUniquePageLoadId(),
			},
		},
		pageState: {
			contentId,
			routeName: name,
		},
	},
	MainLayout: false,
	BannerContext: { includeTopNav: false },
});
